import React from 'react';
import './scss/empty-view.scss';
import EmptyViewProp from './properties/empty-view';

function EmptyView({ title, desc }: EmptyViewProp): React.ReactElement {
  return (
    <div className="row empty-view p-5">
      <div className="col text-center">
        <p style={{
          fontStyle: 'italic',
          fontSize: '1.1rem',
        }}
        >
          {title}
        </p>
        <p style={{
          fontStyle: 'italic',
          fontSize: '1rem',
          color: 'grey',
        }}
        >
          {desc}
        </p>
      </div>
    </div>
  );
}

export default EmptyView;
